import _ from 'lodash';
import { fetchOrgsWithKeys, newToken } from './api';

const initialState = {
  status: 'unfetched',
  orgs: null,
  error: null,
};

const mutations = {
  LOADING(state) {
    state.status = 'loading';
  },
  SUCCESS(state, data) {
    state.status = 'fetched';
    state.orgs = data;
  },
  FAILURE(state, msg) {
    state.status = 'failed';
    state.error = msg;
  },
  CREATING(state, { id }) {
    const orgIx = _.findIndex(state.orgs, { id });
    state.orgs = [
      ...state.orgs.slice(0, orgIx),
      {
        ...state.orgs[orgIx],
        loading: true,
      },
      ...state.orgs.slice(orgIx + 1),
    ];
  },
  CREATED(state, org) {
    const orgIx = _.findIndex(state.orgs, { id: org.id });
    state.orgs = [
      ...state.orgs.slice(0, orgIx),
      { ...state.orgs[orgIx], ...org },
      ...state.orgs.slice(orgIx + 1),
    ];
  },
  CREATE_TOKEN_FAILED(state, { id, message }) {
    const orgIx = _.findIndex(state.orgs, { id });
    state.orgs = [
      ...state.orgs.slice(0, orgIx),
      {
        ...state.orgs[orgIx],
        loading: false,
        error: message,
      },
      ...state.orgs.slice(orgIx + 1),
    ];
  },
};

const actions = {
  async fetch({ commit }) {
    commit('LOADING');
    try {
      const orgs = await fetchOrgsWithKeys();
      commit('SUCCESS', orgs);
    } catch (e) {
      commit('FAILURE', e);
    }
  },
  async newToken({ commit }, { id }) {
    commit('CREATING', { id });
    try {
      const data = await newToken(id);
      commit('CREATED', data);
    } catch (e) {
      commit('CREATE_TOKEN_FAILED', { id, message: e.message });
    }
  },
};

const getters = {
  fetchPayload(state, gtters, rootState, rootGetters) {
    if (!rootGetters.loggedIn) return null;
    return {
      loggedIn: true,
    };
  },
  showError(state) {
    if (state.status === 'failed') {
      return true;
    }
    return false;
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
  hagridResources: {
    fetch: 'fetchPayload',
    fetchVars: 'fetchPayload',
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Orgs.js